import { combineReducers, createStore } from "redux";
import { authReducer } from "./reducers/authReducer";
import { modalReducer } from "./reducers/modalReducer";
import { currencyReducer } from "./reducers/currencyReducer";
import { composeWithDevTools } from "redux-devtools-extension";
const reducers = combineReducers({
  authReducer, modalReducer,currencyReducer
});
export const store = createStore(reducers, composeWithDevTools());
